import { Button, FormLabel, Grid, Modal, TextField } from "@mui/material";
import { FunctionComponent, useState } from "react";
import ContainerModal from "../../../../../components/modalExportar/components/containerModal";
import { SelectMinisterioGrupo } from "../../../../../components/selects/ministerioGrupo";
import { useServicesMensagens } from "../../context/getMembros";
import { SelectFrequencia } from "../../../../../components/selects/frequencia";


interface ModalIncluirMensagemProps {

}

const ModalIncluirMensagem: FunctionComponent<ModalIncluirMensagemProps> = () => {

  const { alterMensagem, mensagem, clearMensagem, handleSubmit } = useServicesMensagens()

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onClose = () => { setIsOpen(false); clearMensagem() };

  const onOpen = () => setIsOpen(true);

  return (<>
    <Modal open={isOpen} onClose={onClose}>
      <ContainerModal>
        <Grid sx={{ borderBottom: '1px solid #ccc', mb: 1, paddingY: 1 }}>
          <p style={{ fontSize: '16px', fontWeight: '600' }}>Mensagem</p>
        </Grid>

        <SelectMinisterioGrupo
          action={(event) => alterMensagem('ministerioGrupo', event?.target?.value)}
          valor={mensagem?.ministerioGrupo}
        />

        <Grid display={'grid'}>
          <FormLabel>Mensagem</FormLabel>
          <TextField
            onChange={(event) => alterMensagem('mensagem', event?.target?.value?.replace(/(script)|(SCRIPT)|(<html>)/, ''))}
            value={mensagem?.mensagem}
          />
        </Grid>

        <Grid display={'grid'}>
          <FormLabel>Link</FormLabel>
          <TextField
            onChange={(event) => alterMensagem('link', event?.target?.value?.replace(/(script)|(SCRIPT)|(<html>)/, ''))}
            value={mensagem?.link}
          />
        </Grid>

        <SelectFrequencia
          valAsNumber
          action={(event) => alterMensagem('frequencia', event?.target?.value)}
          valor={mensagem?.frequencia}
        />

        <Grid display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={1}>
          <Button color='error' onClick={onClose}>Cancelar</Button>
          <Button
            variant="contained"
            sx={{ boxShadow: 'none' }}
            onClick={handleSubmit}
          >
            Criar
          </Button>
        </Grid>
      </ContainerModal>
    </Modal>
    <Button
      onClick={onOpen}
      variant="contained"
      sx={{ boxShadow: 'none' }}
    >
      Criar
    </Button>
  </>);
}

export default ModalIncluirMensagem;
